module.exports = __webpack_public_path__ + "static/img/product-poster-8.0b865d2e.png";